// Reine, frameworkfreie Whiteboard-Logik. Koordinaten normalisiert (0..1).

export function emptyState() {
  return { ops: [], background: { kind: 'blank' } };
}

export function normalizePoint(px, py, w, h) {
  return { x: w ? px / w : 0, y: h ? py / h : 0 };
}

export function denormalizePoint(nx, ny, w, h) {
  return { x: nx * w, y: ny * h };
}

let _seq = 0;
export function newId() {
  _seq += 1;
  return `${Date.now()}-${_seq}`;
}

export function makeStroke(id, color, width, eraser, points) {
  return { type: 'stroke', id, color, width, eraser: !!eraser, points: points.slice() };
}
export function makeShape(id, kind, x1, y1, x2, y2, color, width) {
  return { type: 'shape', id, kind, x1, y1, x2, y2, color, width };
}
export function makeText(id, x, y, content, color, size) {
  return { type: 'text', id, x, y, content, color, size };
}
export function makeSetBackground(kind, imageUrl) {
  return imageUrl
    ? { type: 'setBackground', kind, imageUrl }
    : { type: 'setBackground', kind };
}
export function makeClear() {
  return { type: 'clear' };
}

// Wendet eine Op auf den State an und gibt einen NEUEN State zurück.
export function applyOp(state, op) {
  switch (op.type) {
    case 'stroke': {
      const idx = state.ops.findIndex((o) => o.id === op.id && o.type === 'stroke');
      if (idx >= 0) {
        const ops = state.ops.slice();
        const existing = ops[idx];
        ops[idx] = { ...existing, points: existing.points.concat(op.points) };
        return { ...state, ops };
      }
      return { ...state, ops: state.ops.concat([{ ...op, points: op.points.slice() }]) };
    }
    case 'shape':
    case 'text':
      return { ...state, ops: state.ops.concat([op]) };
    case 'setBackground': {
      const background = op.imageUrl ? { kind: op.kind, imageUrl: op.imageUrl } : { kind: op.kind };
      return { ...state, background };
    }
    case 'clear':
      return { ...state, ops: [] };
    default:
      return state;
  }
}
